export default __webpack_public_path__ + "static/media/filtersIcon.97b2898a.svg";